import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const NotificationSection = ({ payslip }) => {
  const { t } = useTranslation();
  const canAccessToPayslip = payslip?.isReleased;
  return (
    <div className="l-wrap-xs u-pt100">
      <div className="l-box-message">
        <p className="m-title-sub u-pt0 u-ta-c" style={{ whiteSpace: 'pre-line' }}>
          {payslip && !canAccessToPayslip
            ? t('features.MyData.components.payroll.PayrollDetailShow.is_confirmed_payslip_accessible', {
                date_time: moment(payslip.releaseDate).format('HH:mm DD/MM/YYYY'),
                current_slip: moment(payslip.paymentDate).format('MM/YYYY')
              })
            : t('features.MyData.components.payroll.PayrollDetailShow.There_is_no_registered_salary_data')}
        </p>
        <p className="u-ta-c">
          {t(
            'features.MyData.components.payroll.PayrollDetailShow.If_you_have_any_questions_please_contact_your_administrator'
          )}
        </p>
      </div>
    </div>
  );
};

export default NotificationSection;
